import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    paper: [],
    pr: {},
    user: {},
    loginUser: {},
    userInfo: {},
    userErrorAnswers: []
  },
  mutations: {
    change (state, params) {
      state.paper = params
    },
    paperIdChange(state, pars) {
      state.pr = pars
    },
    userNameChange(state, pars) {
      state.user = pars
    },
    loginUserChange(state, pars) {
      state.loginUser = pars
    },
    userInfoChange(state, pars) {
      state.userInfo = pars
    },
    userErrorAnswersChange(state, pars) {
      state.userErrorAnswers = pars
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js